import { HOME_PAGE_ROUTES } from "./page";
import { Props } from "@/models";
import {
  inactive_history,
  inactive_home,
  inactive_payment,
  inactive_profile,
  inactive_wallet,
} from "@/assets";
import {
  DocumentText,
  EmptyWallet,
  Home2,
  Mobile,
  Money,
  ProfileCircle,
  RepeatCircle,
  TransactionMinus,
} from "iconsax-react";

export const payxpressMenuList: Array<Props.MenuNav> = [
  {
    to: HOME_PAGE_ROUTES.HOME,
    Icon: Home2,
    isRed: true,
    title: "Home",
    activeClassName: "text-[#FF6D00] bg-[#FF6D001A] hover:bg-[#ff6f0075]",
    inactiveClassName: "text-white bg-[#FF6D00] hover:bg-[#d75e04]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.AIRTIME,
    Icon: Mobile,
    title: "Airtime & Data",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.BILL_PAYMENTS,
    Icon: TransactionMinus,
    isRed: true,
    title: "Bill Payment",
    activeClassName: "text-[#FF6D00] bg-[#FF6D001A] hover:bg-[#ff6f0075]",
    inactiveClassName: "text-white bg-[#FF6D00] hover:bg-[#d75e04]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.RECURRING_PAYMENTS,
    Icon: RepeatCircle,
    title: "Recurring Payments",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.WALLET,
    Icon: EmptyWallet,
    isRed: true,
    title: "Wallet",
    activeClassName: "text-[#FF6D00] bg-[#FF6D001A] hover:bg-[#ff6f0075]",
    inactiveClassName: "text-white bg-[#FF6D00] hover:bg-[#d75e04]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.TRANSACTIONS,
    Icon: DocumentText,
    title: "Transactions",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
];

export const payxpressMobileMenuList: Array<Props.MenuNav> = [
  {
    to: HOME_PAGE_ROUTES.HOME,
    Icon: Home2,
    inactiveSrc: inactive_home,
    title: "Home",
    activeClassName: "text-[#FF6D00] bg-[#FF6D001A] hover:bg-[#ff6f0075]",
    inactiveClassName: "text-white bg-[#FF6D00] hover:bg-[#d75e04]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.BILL_PAYMENTS,
    Icon: Money,
    inactiveSrc: inactive_payment,
    title: "Payment",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.WALLET,
    Icon: EmptyWallet,
    inactiveSrc: inactive_wallet,
    title: "Wallet",
    activeClassName: "text-[#FF6D00] bg-[#FF6D001A] hover:bg-[#ff6f0075]",
    inactiveClassName: "text-white bg-[#FF6D00] hover:bg-[#d75e04]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.TRANSACTIONS,
    Icon: DocumentText,
    inactiveSrc: inactive_history,
    title: "History",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
  {
    to: HOME_PAGE_ROUTES.SETTINGS,
    Icon: ProfileCircle,
    inactiveSrc: inactive_profile,
    title: "Account",
    activeClassName: "text-[#006F01] bg-[#006F011A] hover:bg-[#006F0175]",
    inactiveClassName: "text-white bg-[#006F01] hover:bg-[#225222]",
    comingSoon: false,
  },
];
